export const DEFAULT_BUSINESS_CASE_TEST_DRIVE_FOLLOW_UP_MINIMUM_DAYS = 1;
